/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetRolesWithTopRelatedResources200ResponseInner
 */
export interface GetRolesWithTopRelatedResources200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'resourceScope': GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'role': GetRolesWithTopRelatedResources200ResponseInnerRoleEnum;
}

export const GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum = typeof GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum[keyof typeof GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum];
export const GetRolesWithTopRelatedResources200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRolesWithTopRelatedResources200ResponseInnerRoleEnum = typeof GetRolesWithTopRelatedResources200ResponseInnerRoleEnum[keyof typeof GetRolesWithTopRelatedResources200ResponseInnerRoleEnum];


